export enum CondicionantesEnum {
  DataCompra = 'Data da Compra',
  DataAlvaraAprovacao = 'Alvará de Aprovação',
  DataAlvaraExecucao = 'Alvará de Execução',
  DataRegistroEscritura = 'Escritura',
  DataPrevisaoRi = 'RI',
  DataPrevisaoLancamento = 'Lançamento',
  OutraData = 'Outra Data'
}
